import { ReactNode } from 'react'
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SortableHeaderProps {
  label: ReactNode
  isSorted?: boolean
  sortDirection?: 'asc' | 'desc'
  onSort?: () => void
  className?: string
  iconSize?: number
}

export const SortableHeader = ({
  label,
  isSorted,
  sortDirection,
  onSort,
  className,
  iconSize = 16,
}: SortableHeaderProps) => {
  return (
    <div
      className={cn('flex items-center gap-2 cursor-pointer', className)}
      onClick={onSort}
    >
      {label}
      {isSorted ? (
        sortDirection === 'asc' ? (
          <ArrowUp size={iconSize} />
        ) : (
          <ArrowDown size={iconSize} />
        )
      ) : (
        <ChevronsUpDown size={iconSize} />
      )}
    </div>
  )
}
